import { withStyles } from '@mui/styles'
import { Select } from '@mui/material'

export const ITEM_HEIGHT = 48
export const ITEM_PADDING_TOP = 8

export const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
      borderRadius: '12px',
      border: '1px solid #ddd',
      backgroundColor: '#fff',
    },
  },
}

export const getStyles = (name, selected, theme) => ({
  fontWeight: selected.includes(name)
    ? theme.typography.fontWeightMedium
    : theme.typography.fontWeightRegular,
})

export const CustomSelectMultiple = withStyles({
  root: {
    '& .MuiSelect-select': {
      padding: '8px 12px',
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      borderRadius: '25px',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
  },
})(Select)

export default CustomSelectMultiple
